/**
 * --------------------------------------------
 * KANYOS CascadeDropdownList.js
 * License ANZAS
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'CascadeDropdownList'
const DATA_KEY = 'lte.cascadedropdownlist'
const EVENT_KEY = `.${DATA_KEY}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

const EVENT_CHANGED = `changed${EVENT_KEY}`

// const SELECTOR_DATA_TOGGLE = '[data-widget="cascade-dropdown-list"]'

const Default = {
  dataSource: undefined,
  cascadeKey: undefined,
  selectedValue: undefined,
  addEmptyOption: true,
  onChange(item) {
    return item
  }
}

/**
 * Class Definition
 * ====================================================
 */

class CascadeDropdownList {
  constructor(element, config) {
    this._config = config
    this._element = element

    this._init()
  }

  change(item) {
    // console.debug(item)
    this._config.onChange.call(item, item.val())

    $(this._element).trigger($.Event(EVENT_CHANGED))
  }

  // Private

  _init() {
    this._element.empty()
    this._element.removeAttr('disabled')

    if (this._config.cascadeKey === undefined ||
      this._config.dataSource === undefined ||
      this._config.dataSource.CascadeItems === undefined ||
      this._config.dataSource.CascadeItems.length === 0) {
      this._element.attr('disabled', 'true')
      return
    }

    for (let i = 0; i < this._config.dataSource.CascadeItems.length; i++) {
      const cascadeItem = this._config.dataSource.CascadeItems[i]

      if (cascadeItem.CascadeKey !== this._config.cascadeKey) {
        continue
      }

      if (cascadeItem.CascadeList === undefined ||
        cascadeItem.CascadeList.ListItems === undefined ||
        cascadeItem.CascadeList.ListItems.length === 0) {
        this._element.attr('disabled', 'true')
        break
      }

      if (this._config.addEmptyOption) {
        this._element.append($('<option />'))
      }

      for (let i = 0; i < cascadeItem.CascadeList.ListItems.length; i++) {
        const listItem = cascadeItem.CascadeList.ListItems[i]

        const $option = $('<option />', {
          text: listItem.ItemText,
          value: listItem.ItemValue,
          selected: this._config.selectedValue === listItem.ItemValue
        })

        this._element.append($option)
      }

      this._element.on('change', event => {
        this.change($(event.target))
      })

      this.change($(this._element))
    }
  }

  // Static

  static _jQueryInterface(config) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = $(this).data()
      }

      const _options = $.extend({}, Default, typeof config === 'object' ? config : data)
      const plugin = new CascadeDropdownList($(this), _options)

      $(this).data(DATA_KEY, typeof config === 'object' ? config : data)

      if (config === 'init') {
        plugin[config]()
      }
    })
  }
}

/**
 * Data API
 * ====================================================
 */

// $(window).on('load', () => {
//   CascadeDropdownList._jQueryInterface.call($(SELECTOR_DATA_TOGGLE))
// })

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = CascadeDropdownList._jQueryInterface
$.fn[NAME].Constructor = CascadeDropdownList
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return CascadeDropdownList._jQueryInterface
}

export default CascadeDropdownList
